<template>
  <div class="kt-portlet kt-portlet--mobile">
    <!-- begin: Single Modal -->
    <router-view />
    <!-- end: Single Modal -->
    <!--begin::Form-->
    <form class="kt-form" ref="form">
      <div class="kt-portlet__head kt-portlet__head--lg">
        <div class="kt-portlet__head-label">
          <span class="kt-portlet__head-icon">
            <i class="kt-font-brand flaticon-home"></i>
          </span>
          <h3 class="kt-portlet__head-title">
            {{ this.$route.meta.breadcrumb }} <strong>{{ qiJobNumber }}</strong>
          </h3>
        </div>
      </div>
      <div class="kt-portlet__body">
        <div class="kt-section kt-section--first">
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>สถานะการดำเนินการ :</strong></label>
                <span class="form-control-plaintext" v-html="qiStatusName"></span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class=" mb-0"><strong>วันที่สร้าง :</strong></label>
                <span class="form-control-plaintext">{{ createdDate }}</span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0">
                  <strong>
                    {{ 
                      qiTypeCode === 'JOB_QI_TYPE_EVALUATE' ? 'วันที่ประเมินเสร็จสิ้น' : 
                      qiTypeCode === 'JOB_QI_TYPE_REPAIR' ? 'วันที่ซ่อมเสร็จสิ้น' : 
                      qiTypeCode === 'JOB_QI_TYPE_DRAWBACK' ? 'วันที่ช่างบันทึกข้อมูลเบิก/คืน' : 
                      'วันที่อัพเดทล่าสุด'
                    }} :
                  </strong>
                </label>
                <span class="form-control-plaintext">{{ finishedDate }}</span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>ชื่อช่าง :</strong></label>
                <span class="form-control-plaintext">{{ createdUserName }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>ประเภทใบงาน :</strong></label>
                <span class="form-control-plaintext" v-html="qiTypeName"></span>
              </div>
            </div>
            <div v-if="qiTypeCode !== 'JOB_QI_TYPE_DRAWBACK' && qiSubType == 1" class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>BARCODE :</strong></label>
                <span class="form-control-plaintext">{{ barcodeNoOld }}</span>
              </div>
            </div>
            <div v-if="qiTypeCode !== 'JOB_QI_TYPE_DRAWBACK'" class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>ชื่อสินค้า/อุปกรณ์ :</strong></label>
                <span class="form-control-plaintext">{{ materialNameShow }}</span>
              </div>
            </div>
            <div class="col-xl-3 col-md-6" v-if="qiTypeCode !== 'JOB_QI_TYPE_DRAWBACK'">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>จำนวน :</strong></label>
                <span class="form-control-plaintext">
                  {{ amount }}
                  <button
                    v-if="showBarcodeBtn"
                    type="button"
                    class="btn btn-outline-hover-info btn-elevate btn-circle btn-icon ml-3"
                    title="แสดงรายการ BARCODE"
                    @click.prevent="showBarcodesModal(qiJobId)"
                  >
                    <i class="text-info la la-list"></i>
                  </button>
                </span>
              </div>
              <div ref="barcodesModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="modelSingle" aria-hidden="true">
                <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">รายการ BARCODE</h5>
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                      <div class="kt-portlet__body">
                        <div class="kt-section kt-section--first">
                          <div class="row">
                            <div class="col-xl-12">
                              <div class="form-group">
                                <table class="table-sm table-striped table-bordered table-hover" ref="barcodeLocalTable">
                                  <thead>
                                    <tr>
                                      <th class="all text-center">ลำดับ</th>
                                      <th class="all">BARCODE</th>
                                    </tr>
                                  </thead>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xl-3 col-md-6" v-if="qiTypeCode == 'JOB_QI_TYPE_DRAWBACK'">
              <label class="label mb-0"><strong>สถานที่ซ่อมอุปกรณ์:</strong></label>
              <span class="form-control-plaintext">
                {{ qiAreaPlant ? 'ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด' : 'ซ่อมในตัวแทนจำหน่าย' }}
              </span>
            </div>
            <div v-if="qiTypeCode == 'JOB_QI_TYPE_DRAWBACK'" class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>วันที่ยืนยันการตรวจสอบข้อมูล :</strong></label>
                <span class="form-control-plaintext">{{ confirmedDate }}</span>
              </div>
            </div>
            <div v-if="qiTypeCode == 'JOB_QI_TYPE_DRAWBACK'" class="col-xl-3 col-md-6">
              <div class="form-group mb-3">
                <label class="label mb-0"><strong>ผู้ยืนยันการตรวจสอบข้อมูล :</strong></label>
                <span class="form-control-plaintext">{{ confirmedUserName }}</span>
              </div>
            </div>
          </div>

          <div class="kt-section kt-section--first" id="FormMachine" v-if="showFormMachine">
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-sm table-striped table-bordered table-checkable">
                    <thead>
                      <tr class="table-warning">
                        <th colspan="3"><strong>การตรวจสภาพอุปกรณ์หลักเบื้องต้น</strong></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center">1</td>
                        <td>ตัวเครื่องเก่าผุพังจนไม่สามารถนำมาซ่อมได้</td>
                        <td class="text-center">
                          <span v-if="evalData.evalMach1">ใช่</span>
                          <span v-else>ไม่ใช่</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">2</td>
                        <td>คอยล์น้ำยาหล่อเย็น ขาดรั่ว ซึม ชำรุดเสียหายจนไม่สามารถซ่อมได้</td>
                        <td class="text-center">
                          <span v-if="evalData.evalMach2">ใช่</span>
                          <span v-else>ไม่ใช่</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">3</td>
                        <td>ระบบไฟฟ้าในคอมเพรสเซอร์ชำรุดเสียหาย จนไม่สามารถซ่อมได้</td>
                        <td class="text-center">
                          <span v-if="evalData.evalMach3">ใช่</span>
                          <span v-else>ไม่ใช่</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">4</td>
                        <td>วอเตอร์บาศก์ชำรุดเสียหาย จนไม่สามารถซ่อมได้</td>
                        <td class="text-center">
                          <span v-if="evalData.evalMach4">ใช่</span>
                          <span v-else>ไม่ใช่</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">5</td>
                        <td>อุปกรณ์หลักของเครื่องมีไม่ครบ</td>
                        <td class="text-center">
                          <span v-if="evalData.evalMach5">ใช่</span>
                          <span v-else>ไม่ใช่</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="2">สรุปผลตรวจสภาพเบื้องต้นเครื่องเบียร์สด</th>
                        <th class="text-center">
                          <span v-if="evalData.evalFlag === 1" class="text-danger">ซ่อมไม่ได้</span>
                          <span v-else-if="evalData.evalFlag === 2" class="text-success">ซ่อมได้</span>
                          <span v-else-if="evalData.evalFlag === 3" class="text-warning">ไม่เสีย</span>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12">
                  <label>อาการเสีย:</label>
                  <textarea placeholder="อาการเสีย" class="form-control" rows="3" readonly> {{ evalData.evalRemark }} </textarea>
                  <span class="form-text mb-3"></span>
                </div>
              </div>
              <div class="row" v-if="isUnrepair">
                <div class="col-xl-12">
                  <div class="form-check pl-0">
                    <label class="form-check-label kt-checkbox text-danger">
                      <input type="checkbox" class="form-check-input" name="isUnrepair" checked disabled/>
                      <span></span>
                      <strong>ประเมินสภาพเบื้องต้นผิดพลาด : ไม่สามารถซ่อมได้</strong>
                    </label>
                  </div>
                  <span class="form-text"></span>
                </div>
                <div class="col-xl-12">
                  <label class="label"><strong>สรุปอาการ และข้อเสนอแนะ :</strong></label>
                  <textarea placeholder="สรุปอาการ และข้อเสนอแนะ" class="form-control" rows="3" readonly> {{ UnrepairRemark }} </textarea>
                  <span class="form-text mb-3"></span>
                </div>
              </div>
            </div>
          </div>

          <div class="kt-section kt-section--first" id="FormEquipment" v-if="showFormEquipment">
            <div class="kt-section__body">
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-sm table-striped table-bordered table-checkable">
                    <thead>
                      <tr class="table-info">
                        <th colspan="3"><strong>การตรวจสภาพอุปกรณ์เสริมเบื้องต้น</strong></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="text-center">1</td>
                        <td>อุปกรณ์เสริม มีส่วนประกอบหลักไม่ครบ เช่น แกนกลางอุปกรณ์,บอดี้หลัก</td>
                        <td class="text-center">
                          <span v-if="evalData.evalEqpt1">ใช่</span>
                          <span v-else>ไม่ใช่</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">2</td>
                        <td>อุปกรณ์เสริมมีการรั่วซึมภายในระบบชำรุดจนไม่สามารถนำมาซ่อมแซม</td>
                        <td class="text-center">
                          <span v-if="evalData.evalEqpt2">ใช่</span>
                          <span v-else>ไม่ใช่</span>
                        </td>
                      </tr>
                      <tr>
                        <td class="text-center">3</td>
                        <td>อุปกรณ์เสริม ไม่สมบูรณ์ จนราคาประเมินซ่อมเกินกว่า 50% ของราคาสินค้า</td>
                        <td class="text-center">
                          <span v-if="evalData.evalEqpt3">ใช่</span>
                          <span v-else>ไม่ใช่</span>
                        </td>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="2">สรุปผลตรวจสภาพเบื้องต้นอุปกรณ์เบียร์สด</th>
                        <th class="text-center">
                          <span v-if="evalData.evalFlag === 1" class="text-danger">ซ่อมไม่ได้</span>
                          <span v-else-if="evalData.evalFlag === 2" class="text-success">ซ่อมได้</span>
                          <span v-else-if="evalData.evalFlag === 3" class="text-warning">ไม่เสีย</span>
                        </th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row">
                <div class="col-xl-12">
                  <label>อาการเสีย:</label>
                  <textarea placeholder="อาการเสีย" class="form-control" rows="5" readonly> {{ evalData.evalRemark }} </textarea>
                  <span class="form-text mb-3"></span>
                </div>
              </div>
            </div>
          </div>

          <!-- Form เบิก/คืน -->
          <div class="kt-section kt-section--first" id="FormDrawback" v-if="showFormDrawback">
              <div class="kt-section__body">
                  <label class="label mb-0"><strong>ข้อมูลการเบิก/คืน อุปกรณ์เบียร์สด :</strong></label>
                  <span class="form-text mb-3"></span>
                  <div class="row">
                      <div class="col-sm-12 table-responsive">
                          <table class="table table-sm table-striped table-bordered table-checkable">
                              <thead>
                                  <tr :class="qiSubType === 1 ? 'table-warning' : 'table-info'">
                                      <th class="text-center">ลำดับ</th>
                                      <th class="text-center">รายการอุปกรณ์</th>
                                      <th class="text-center">จำนวน</th>
                                      <th class="text-center">ราคา/หน่วย</th>
                                      <th class="text-center">มูลค่ารวม</th>
                                      <th class="text-center">หมายเหตุ</th>
                                  </tr>
                              </thead>
                              <tbody>
                                  <tr v-for="(item, index) in items" :key="item.qiJobItemId">
                                      <td class="text-center">{{ index + 1 }}</td>
                                      <td>{{ item.materialNameShow }}</td>
                                      <td class="text-center">{{ item.quantity }}</td>
                                      <td class="text-right">{{ item.unitPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                                      <td class="text-right">{{ (item.quantity * item.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                                      <td>{{ item.remark }}</td>
                                  </tr>
                                  <tr>
                                      <td colspan="2" class="text-right"><strong>จำนวนรวม/มูลค่ารวม</strong></td>
                                      <td class="text-center"><strong>{{ totalQuantity }}</strong></td>
                                      <td class="text-center"></td>
                                      <td class="text-right"><strong>{{ totalValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong></td>
                                  </tr>
                              </tbody>
                          </table>
                      </div>
                  </div>

                  <div class="form-group"></div>
                  <div class="row">
                      <div class="col-xl-2 col-md-2 col-sm-2">
                          <label class="label">
                              <strong v-if="pictures.length && pictures[0].downloadUrl">รูปภาพอุปกรณ์ :</strong>
                              <strong v-else>รูปภาพอุปกรณ์ : ไม่มีภาพถ่าย</strong>
                          </label>
                          <div v-if="pictures.length && pictures[0].downloadUrl">
                              <div class="position-relative">
                                  <div class="p-1 d-flex flex-column justify-content-center align-items-center border-dashed">
                                      <img v-if="pictures[0]" :src="pictures[0].downloadUrl" @click="showModal(pictures[0].downloadUrl)" style="object-fit: contain; width: 100%; height: 100%;">
                                  </div>
                              </div>
                          </div>

                          
                          <div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                              <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                                  <div class="modal-content mr-4">
                                      <div class="modal-header">
                                          <h5 class="modal-title">ภาพถ่าย</h5>
                                          <button type="button" class="close" aria-label="Close" @click="closeModal">
                                              <span aria-hidden="true">&times;</span>
                                          </button>
                                      </div>
                                      <div class="modal-body">
                                          <img :src="modalImageURL" style="max-width: 90%; max-height: 90%; margin: 0 auto; display: block;">

                                          
                                      </div>
                                      <div class="modal-footer">
                                          
                                          <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeModal">
                                              <i class="la la-close"></i> ปิดหน้าต่าง
                                          </button>
                                      </div>
                                  </div>
                              </div>
                          </div>
                          
                      </div>
                  </div>

              </div>
          </div>
           
          <!-- Form Repair -->
          <div class="kt-section kt-section--first" id="FormRepair" v-if="showFormRepair">
            <div class="kt-section__body">
              <div class="row">
                <div v-if="!qiAreaPlant" class="col-xl-6">
                  <label class="label mb-0"><strong>สถานที่ซ่อมอุปกรณ์:</strong></label>
                  <span class="form-control-plaintext">
                    {{ 'ซ่อมในตัวแทนจำหน่าย' }} <strong>{{ agentCodeSap ? ' >> '+agentName+' ('+agentCodeSap+')' : ''}}</strong>
                  </span>
                </div>
                <div v-else class="col-xl-3">
                  <label class="label mb-0"><strong>สถานที่ซ่อมอุปกรณ์:</strong></label>
                  <span class="form-control-plaintext">
                    {{ 'ซ่อมที่คลังอุปกรณ์เบียร์สดปากเกร็ด' }} 
                  </span>
                </div>
                <div v-if="qiAreaPlant && qiTypeCode == 'JOB_QI_TYPE_REPAIR'" class="col-xl-3 col-md-6">
                  <div class="form-group">
                    <label class="label mb-0"><strong>วันที่รับเข้าคลังดี :</strong></label>
                    <span class="form-control-plaintext">{{ confirmedDate }}</span>
                  </div>
                </div>
                <div v-if="qiAreaPlant && qiTypeCode == 'JOB_QI_TYPE_REPAIR'" class="col-xl-3 col-md-6">
                  <div class="form-group">
                    <label class="label mb-0"><strong>ผู้รับเข้าคลังดี :</strong></label>
                    <span class="form-control-plaintext">{{ confirmedUserName }}</span>
                  </div>
                </div>
              </div>

              <div v-if="!isUnrepair">

              <label class="label"><strong>{{ tableName }}</strong></label>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table table-sm table-striped table-bordered table-checkable">
                    <thead>
                      <tr :class="qiSubType === 1 ? 'table-warning' : 'table-info'">
                        <th class="text-center">ลำดับ</th>
                        <th>รายการ</th>
                        <th class="text-center">ผลการตรวจสอบ</th>
                        <th class="text-center">หมายเหตุ(กรณีไม่ปกติ)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in tableDataRepair" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ row.item }}</td>
                        <td class="text-center">{{ row.result === null ? '-' : (row.result ? 'ปกติ' : 'ไม่ปกติ') }}</td>
                        <td class="text-center">{{ row.remark || '' }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="form-group"></div>
              <label class="label"><strong>ขั้นตอนมาตรฐานการซ่อมอุปกรณ์ :</strong></label>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table-sm table-striped table-bordered table-checkable" style="width:100%">
                    <tbody>
                      <tr v-for="(item, index) in tableFormData" :key="index">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ item.label }}</td>
                        <td v-html="item.variable"></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="form-group"></div>
              <div class="row">
                <div class="col-xl-2 col-md-2 col-sm-2">
                  <label class="label">
                    <strong v-if="pictures.length && pictures[0].downloadUrl">ภาพถ่าย :</strong>
                    <strong v-else>ภาพถ่าย : ไม่มีภาพถ่าย</strong>
                  </label>
                  <div v-if="pictures.length && pictures[0].downloadUrl">
                    <div class="position-relative">
                      <div class="p-1 d-flex flex-column justify-content-center align-items-center border-dashed">
                        <img v-if="pictures[0]" :src="pictures[0].downloadUrl" @click="showModal(pictures[0].downloadUrl)" style="object-fit: contain; width: 100%; height: 100%;">
                      </div>
                    </div>
                  </div>
                  <div class="modal fade" id="imageModal" tabindex="-1" role="dialog" aria-labelledby="imageModalLabel" aria-hidden="true" data-backdrop="static" data-keyboard="false">
                    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
                      <div class="modal-content mr-4">
                        <div class="modal-header">
                          <h5 class="modal-title">ภาพถ่าย</h5>
                          <button type="button" class="close" aria-label="Close" @click="closeModal">
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <img :src="modalImageURL" style="max-width: 90%; max-height: 90%; margin: 0 auto; display: block;">
                          <button type="button" class="close" aria-label="Close" @click="closeModal">
                            <h6 class="modal-title"><i class="la la-close"></i> ปิดหน้าต่าง</h6>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-group"></div>
              <label class="label"><strong>อะไหล่สำหรับซ่อม/ล้าง :</strong></label>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table-sm table-striped table-bordered table-hover" style="width:100%; table-layout: fixed;">
                    <colgroup>
                      <col style="width: 10%;">
                      <col style="width: 40%;">
                      <col style="width: 10%;">
                      <col style="width: 20%;">
                      <col style="width: 20%;">
                    </colgroup>
                    <thead>
                      <tr>
                        <th class="text-center">ลำดับ</th>
                        <th>รายการ</th>
                        <th class="text-center">จำนวน</th>
                        <th class="text-right">ราคาต่อหน่วย</th>
                        <th class="text-right">ราคาสุทธิ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in items" :key="item.qiJobItemId">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ item.materialNameShow }}</td>
                        <td class="text-center">{{ item.quantity.toLocaleString('en-US') }}</td>
                        <td class="text-right">{{ item.unitPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                        <td class="text-right">{{ (item.quantity * item.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="2">รวมจำนวน/ราคาอะไหล่ทั้งสิ้น</th>
                        <td class="text-center"><strong>{{ totalQuantity.toLocaleString('en-US') }}</strong></td>
                        <td></td>
                        <td class="text-right"><strong>{{ totalValue.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="form-group"></div>
              <label class="label"><strong>ค่าบริการ :</strong></label>
              <div class="row">
                <div class="col-sm-12 table-responsive">
                  <table class="table-sm table-striped table-bordered table-hover" style="width:100%; table-layout: fixed;">
                    <colgroup>
                      <col style="width: 10%;">
                      <col style="width: 40%;">
                      <col style="width: 10%;">
                      <col style="width: 20%;">
                      <col style="width: 20%;">
                    </colgroup>
                    <thead>
                      <tr>
                        <th class="text-center">ลำดับ</th>
                        <th>รายการ</th>
                        <th class="text-center">จำนวน</th>
                        <th class="text-right">ราคาต่อหน่วย</th>
                        <th class="text-right">ราคาสุทธิ</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in services" :key="item.qiJobServiceId">
                        <td class="text-center">{{ index + 1 }}</td>
                        <td>{{ item.serviceName }}</td>
                        <td class="text-center">{{ item.quantity.toLocaleString('en-US') }}</td>
                        <td class="text-right">{{ item.unitPrice.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                        <td class="text-right">{{ (item.quantity * item.unitPrice).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                      </tr>
                      <tr>
                        <th class="text-center" colspan="2">รวมจำนวน/ราคาค่าบริการทั้งสิ้น</th>
                        <td class="text-center"><strong>{{ totalQuantityService.toLocaleString('en-US') }}</strong></td>
                        <td></td>
                        <td class="text-right"><strong>{{ totalValueService.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</strong></td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="form-group"></div>
              <div class="row">
                <div class="col-xl-12">
                  <label class="label"><strong>สรุปอาการ และข้อเสนอแนะ :</strong></label>
                  <textarea placeholder="สรุปอาการ และข้อเสนอแนะ" class="form-control" rows="5" readonly> {{ remark }} </textarea>
                  <span class="form-text mb-3"></span>
                </div>
              </div>

              </div>
              <div v-else>
                <div class="row">
                  <div class="col-xl-12">
                    <label class="label"><strong>สรุปอาการ และข้อเสนอแนะ :</strong></label>
                    <textarea placeholder="สรุปอาการ และข้อเสนอแนะ" class="form-control" rows="5" readonly> {{ UnrepairRemark }} </textarea>
                    <span class="form-text mb-3"></span>
                  </div>
                  <div class="col-xl-12">
                    <div class="form-check pl-0">
                      <label class="form-check-label kt-checkbox text-danger">
                        <input type="checkbox" class="form-check-input" name="isUnrepair" checked disabled/>
                        <span></span>
                        <strong>ประเมินสภาพเบื้องต้นผิดพลาด : ไม่สามารถซ่อมได้</strong>
                      </label>
                    </div>
                    <span class="form-text mb-3"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="kt-portlet__foot">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="$router.go(-1)"
        >
          <i class="la la-close"></i> ย้อนกลับ
        </button>
      </div>
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import router from "../../router";

export default {
  data: function() {
    var self = this;
    return {
      qiJobId: null,
      qiJobNumber: null,
      qiTypeCode: '',
      qiSubType: 0,
      qiStatusName: null,
      qiAreaPlant: true,
      agentCodeSap: '',
      agentName: '',
      createdDate: null,
      createdUserName: null,
      finishedDate: null,
      confirmedDate: null,
      confirmedUserName: null,
      qiTypeName: null,
      barcodeNoOld: null,
      materialNameShow: null,
      qiSubProductType: null,
      amount: null,
      showBarcodeBtn: false,
      showFormMachine: false,
      showFormEquipment: false,
      showFormDrawback: false,
      showFormRepair: false,
      evalData: {
        evalMach1: null,
        evalMach2: null,
        evalMach3: null,
        evalMach4: null,
        evalMach5: null,
        evalRemark: null,
        evalEqpt1: null,
        evalEqpt2: null,
        evalEqpt3: null,
        evalFlag: null,
      },
      items: [],
      services: [],
      pictures: [],
      modalImageURL: '',
      tableName: '',
      tableFormData: [],
      tableDataRepair: [],
      remark: '',
      isUnrepair: false,
      UnrepairRemark: null,
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;
    let user = await this.$root.getUser();

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/QIJobs/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          //console.log(response.data);
          if (response.data != null) {
            self.qiJobId = response.data.qiJobId;
            self.isUnrepair = response.data.isUnrepair;
            self.UnrepairRemark = response.data.unrepairRemark;
            self.qiJobNumber = response.data.qiJobNumber ? `เลขที่ใบงาน : ${response.data.qiJobNumber}` : '';
            self.qiTypeCode = response.data.qiTypeCode;
            self.qiSubType = response.data.qiSubType;
            self.agentCodeSap = response.data.agentCodeSap;
            self.agentName = response.data.agentName;

            let qiStatusCode = response.data.qiStatusCode;
            let evalFlag = response.data.formData ? response.data.formData.evalFlag : null;;
            let statusIcon = '';
            let statusText = self.qiStatusName = response.data.qiStatusName;
            if (qiStatusCode == "JOB_QI_STATUS_PENDING") {
              statusIcon = '<i class="fa fa-sync-alt"></i>';
            } else if (qiStatusCode == "JOB_QI_STATUS_SUCCESS") {
              statusIcon = '<i class="fa fa-check-circle"></i>';
              if (evalFlag === 1) {
                statusText += ' <span class="text-danger">(ซ่อมไม่ได้)</span>';
              } else if (evalFlag === 2) {
                statusText += ' <span class="text-success">(ซ่อมได้)</span>';
              } else if (evalFlag === 3) {
                statusText += ' <span class="text-warning">(ไม่เสีย)</span>';
              }
            } else if (qiStatusCode == "JOB_QI_STATUS_REQUEST_APPROVAL") {
              statusIcon = '<i class="fa fa-file-signature"></i>';
            } else if (qiStatusCode == "JOB_QI_STATUS_REPAIR_COMPLETED") {
              statusIcon = '<i class="fa fa-check"></i>';
            } else if (qiStatusCode == "JOB_QI_STATUS_CANCEL") {
              statusIcon = '<i class="fa fa-ban text-danger"></i>';
            }
            self.qiStatusName = statusIcon + ' ' + statusText;

            self.createdDate = response.data.createdDateFormat ? response.data.createdDateFormat : '-';
            self.createdUserName = response.data.createdUserName ? response.data.createdUserName : '-';
            self.finishedDate = response.data.finishedDate  && response.data.finishedUserId != null ? self.setDateFormat(response.data.finishedDate, true) : '-';
            self.confirmedDate = response.data.confirmedDate ? self.setDateFormat(response.data.confirmedDate, true) : '-';
            self.confirmedUserName = response.data.confirmedUserName ? response.data.confirmedUserName : '-';

            let additionalText = '';
            if (response.data.qiTypeCode === "JOB_QI_TYPE_DRAWBACK" && response.data.finishedDate != null) {
              if (response.data.qiSubType === 1) {
                additionalText = ' <span>(เบิก)</span>';
              } else {
                additionalText = ' <span>(คืน)</span>';
              }
            }
            self.qiTypeName = response.data.qiTypeName ? response.data.qiTypeName + additionalText : '-';

            self.barcodeNoOld = response.data.barcodeNoOld ? response.data.barcodeNoOld : '-';
            self.materialNameShow = response.data.materialNameShow ? response.data.materialNameShow : '-';
            self.qiAreaPlant = response.data.qiAreaPlant;

            let qiSubProductType = response.data.qiSubProductType ? response.data.qiSubProductType : 0;
            if (qiSubProductType == 5) {
              self.showBarcodeBtn = true;
            }
            self.amount = response.data.amount ? response.data.amount : '-';

            // แบบฟอร์มแยกแต่ละประเภท,ประเภทย่อยของใบงาน
            if (response.data.qiTypeCode === "JOB_QI_TYPE_EVALUATE" && response.data.finishedDate != null) {
              if (response.data.qiSubType === 1) {
                self.showFormMachine = true;
                self.showFormEquipment = false;
              } else {
                self.showFormMachine = false;
                self.showFormEquipment = true;
              }
              if (response.data.formData) {
                self.evalData.evalMach1 = response.data.formData.evalMach1;
                self.evalData.evalMach2 = response.data.formData.evalMach2;
                self.evalData.evalMach3 = response.data.formData.evalMach3;
                self.evalData.evalMach4 = response.data.formData.evalMach4;
                self.evalData.evalMach5 = response.data.formData.evalMach5;
                self.evalData.evalEqpt1 = response.data.formData.evalEqpt1;
                self.evalData.evalEqpt2 = response.data.formData.evalEqpt2;
                self.evalData.evalEqpt3 = response.data.formData.evalEqpt3;
                self.evalData.evalFlag = response.data.formData.evalFlag;
                self.evalData.evalRemark = response.data.formData.evalRemark;
              }
            } else if (response.data.qiTypeCode ===  "JOB_QI_TYPE_DRAWBACK" && response.data.finishedDate != null) {
              self.showFormDrawback = true;
            } else if (response.data.qiTypeCode ===  "JOB_QI_TYPE_REPAIR" && response.data.finishedDate != null) {
              self.showFormRepair = true;
              self.qiSubProductType = response.data.qiSubProductType
              if (response.data.formData) {
                self.remark = response.data.formData.remark;
                self.setTableData(response.data.qiSubType, response.data.qiSubProductType, response.data.formData);
              }

              //if (response.data.picture && typeof response.data.picture !== 'undefined' && response.data.picture.length > 0) {
              //  async function loadPictures() {
              //    response.data.picture.map(async (element) => {
              //      self.pictures.push({
              //        fileInfoId: element.fileInfoId,
              //        downloadUrl: element.downloadUrl
              //      });
              //    });
              //  }
              //  loadPictures();
              //}
            }

            //=== set pictures ===
            if (response.data.picture && typeof response.data.picture !== 'undefined' && response.data.picture.length > 0) {
                async function loadPictures() {
                    response.data.picture.map(async (element) => {
                        self.pictures.push({
                            fileInfoId: element.fileInfoId,
                            downloadUrl: element.downloadUrl
                        });
                    });
                }
                loadPictures();
            }

              //response.data.picture.forEach((element) => {
              //    self.pictures.push({
              //        fileInfoId: element.fileInfoId,
              //        downloadUrl: element.downloadUrl
              //    });
              //});


            if (response.data.items && Array.isArray(response.data.items)) {
              if (response.data.qiTypeCode == "JOB_QI_TYPE_DRAWBACK") {
                self.amount = response.data.items.reduce((total, item) => total + item.quantity, 0);
              }
              self.items = response.data.items;
            }
            if (response.data.services && Array.isArray(response.data.services)) {
              self.services = response.data.services;
            }
          }
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลใบงานช่างซ่อมคุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลใบงานช่างซ่อมได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });
  },
  methods: {
    showModal(imageURL) {
      this.modalImageURL = imageURL;
      this.isFromImageModal = true;
      $('#imageModal').modal('show');
      $('#imageModal').on('hidden.bs.modal', () => {
        $('body').addClass('modal-open');
      });
    },
    closeModal() {
      $('#imageModal').modal('hide');
    },
    showDispenserProductBrands(items) {
      var text = "";
      //console.log(items);
      if (items != null && items.length > 0) {
        for (let i = 0; i < items.length; i++) {
          text +=
            "[" + items[i].productBrandId + "] " + items[i].productBrandName;
          if (i != items.length - 1) text += ", ";
        }
      }
      return text;
    },
    setDateFormat(dateStr, includeTime = false) {
      let options = {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        calendar: 'gregory'
      };
      if (includeTime) {
        options = {
          ...options,
          hour: '2-digit',
          minute: '2-digit'
        };
      }
      let dateStrFormat = new Date(dateStr).toLocaleDateString('th-TH', options);
      return dateStrFormat;
    },
    setTableData(qiSubType, qiSubProductType, formData) {
      var self = this;
      if (qiSubType === 1) {
        self.tableName = 'การตรวจเช็คเครื่องทำความเย็นเบียร์สด :';
        self.tableDataRepair = [
          { item: 'ตรวจเช็ค ความสมบูรณ์ ภายนอกตัวเครื่อง', result: formData.mach1, remark: formData.machRemark1 },
          { item: 'ตรวจเช็ค ความสมบูรณ์ของ เอจิเตเตอร์', result: formData.mach2, remark: formData.machRemark2 },
          { item: 'ตรวจเช็ค ความสมบูรณ์ของ คอมเพรสเซอร์', result: formData.mach3, remark: formData.machRemark3 },
          { item: 'ตรวจเช็ค ความสมบูรณ์ของ ระบบสายไฟ', result: formData.mach4, remark: formData.machRemark4 },
          { item: 'ตรวจเช็ค ความสมบูรณ์ของ ระบบน้ำยาหล่อลื่น', result: formData.mach5, remark: formData.machRemark5 },
          { item: 'ตรวจเช็ค ความสมบูรณ์ของ ระบบระบายความร้อน', result: formData.mach6, remark: formData.machRemark6 },
          { item: 'ตรวจเช็ค ความสมบูรณ์ของ วอเตอร์บาศก์', result: formData.mach7, remark: formData.machRemark7 },
          { item: 'ตรวจเช็ค ความสมบูรณ์ของ เทอร์โมสตัท', result: formData.mach8, remark: formData.machRemark8 }
        ];

        self.tableFormData = [
          { label: "ถอดประกอบ แยก ชิ้นส่วนอุปกรณ์ ออกจากกัน จุดวางชิ้นส่วนที่ถอดประกอบจุดที่", variable: formData.mach9 || '-' },
          { label: "ทำความสะอาดเพื่อหาร่องรอยอาการเสีย", variable: formData.mach10 ? `จุดล้างที่ ${formData.mach10}` : '-' },
          { label: "เปลี่ยนอะไหล่ เติมสารเคมี ทำสี", variable: (formData.mach11 || formData.mach12) ? `ประเภทน้ำยา ${formData.mach11 || '-'} แรงดัน ${formData.mach12 || '-'} PSI` : '-' },
          { label: "ประกอบชิ้นส่วนอุปกรณ์กลับ", variable: formData.mach13 != null ? (formData.mach13 == 1 || formData.mach13 == '1' ? 'ครบ' : 'ไม่ครบ') : '-' },
          { label: "การทำความสะอาดเพื่อรอส่งชิ้นงาน", variable: formData.mach14 != null ? (formData.mach14 == 1 || formData.mach14 == '1' ? 'ทำแล้ว' : 'ยังไม่ได้ทำ') : '-' },
          { label: "ทดสอบประสิทธิภาพของอุปกรณ์เต็มรูปแบบ ตรวจสอบความสมบูรณ์ของอุปกรณ์", variable: (formData.machTimeStart && formData.machTimeEnd && formData.machTime) ? `เสียบปลั๊กตั้งแต่เวลา ${formData.machTimeStart} - ${formData.machTimeEnd}<br>รวมใช้เวลา ${formData.machTime} นาที` : '-' },
          { label: "การหีบห่ออุปกรณ์ และรับประกันงานซ่อม", variable: formData.mach15 != null ? (formData.mach15 ? 'ซีลม้วนพลาสติก' : '-') : '-' },
          { label: "การส่งอุปกรณ์ซ่อมเสร็จ กลับคลังสินค้า วันที่รับประกัน", variable: formData.machGuaranteeDate ? self.setDateFormat(formData.machGuaranteeDate) : '-' }
        ];
      }
      else {
        if (qiSubProductType === 1) {
          self.tableName = 'การตรวจเช็คหัวจั้ม :';
          self.tableDataRepair = [
            { item: 'ตรวจเช็ค ความสมบูรณ์ ตัวแกนหัวจัมพ์', result: formData.eqptJump1, remark: formData.eqptRemarkJump1 },
            { item: 'ตรวจเช็ค ความสมบูรณ์ ลูกยางหัวจัมพ์', result: formData.eqptJump2, remark: formData.eqptRemarkJump2 }
          ];
        } else if (qiSubProductType === 2) {
          self.tableName = 'การตรวจเช็คเรคกูเรเตอร์';
          self.tableDataRepair = [
            { item: 'ตรวจเช็ค ความสมบูรณ์ ภายนอกเกจวัดแรงดัน', result: formData.eqptGauge1, remark: formData.eqptRemarkGauge1 },
            { item: 'ตรวจเช็ค ความสมบูรณ์ อุปกรณ์พ่วงต่อเกจวัดแรงดันCO2', result: formData.eqptGauge2, remark: formData.eqptRemarkGauge2 }
          ];
        } else if (qiSubProductType === 3) {
          self.tableName = 'การตรวจเช็ควาล์ว :';
          self.tableDataRepair = [
            { item: 'ตรวจเช็ค ความสมบูรณ์ ตัวแกนวาล์ว', result: formData.eqptValve1, remark: formData.eqptRemarkValve1 },
            { item: 'ตรวจเช็ค ความสมบูรณ์ ลูกยางวาล์ว', result: formData.eqptValve2, remark: formData.eqptRemarkValve2 }
          ];
        } else if (qiSubProductType === 4) {
          self.tableName = 'การตรวจเช็คคอยล์ :';
          self.tableDataRepair = [
            { item: 'ตรวจเช็ค ความสมบูรณ์ ภายนอกคอยล์', result: formData.eqptCoil1, remark: formData.eqptRemarkCoil1 }
          ];
        } else if (qiSubProductType === 5) {
          self.tableName = 'การตรวจเช็คหัวจ่ายเบียร์สด :';
          self.tableDataRepair = [
            { item: 'ตรวจเช็ค ความสมบูรณ์ ภายนอกหัวจ่าย', result: formData.eqptDisp1, remark: formData.eqptRemarkDisp1 },
            { item: 'ตรวจเช็ค ความสมบูรณ์ของ แกนน้ำเบียร์', result: formData.eqptDisp2, remark: formData.eqptRemarkDisp2 }
          ];
        }

        self.tableFormData = [
          { label: "ถอดประกอบ แยก ชิ้นส่วนอุปกรณ์ ออกจากกัน จุดวางชิ้นส่วนที่ถอดประกอบจุดที่", variable: formData.eqpt1 || '-' },
          { label: "ทำความสะอาดเพื่อหาร่องรอยอาการเสีย", variable: formData.eqpt2 ? `จุดล้างที่ ${formData.eqpt2}` : '-' },
          { label: "เปลี่ยนอะไหล่", variable: formData.eqpt3 == 1 ? 'ปกติ' : (formData.eqpt3 == null ? '-' : 'เสื่อมสภาพ') },
          { label: "ประกอบชิ้นส่วนอุปกรณ์กลับ", variable: formData.eqpt4 == null ? '-' : (formData.eqpt4 == 1 || formData.eqpt4 == '1' ? 'ครบ' : 'ไม่ครบ') },
          { label: "การทำความสะอาดเพื่อรอส่งชิ้นงาน", variable: formData.eqpt5 == null ? '-' : (formData.eqpt5 == 1 || formData.eqpt5 == '1' ? 'ทำแล้ว' : 'ยังไม่ได้ทำ') },
          { label: "ทดสอบประสิทธิภาพของอุปกรณ์เต็มรูปแบบ ตรวจสอบความสมบูรณ์ของอุปกรณ์", variable: formData.eqptTimeStart && formData.eqptTimeEnd && formData.eqptTime ? `เสียบปลั๊กตั้งแต่เวลา ${formData.eqptTimeStart} - ${formData.eqptTimeEnd}<br>รวมใช้เวลา ${formData.eqptTime} นาที` : '-' },
          { label: "การหีบห่ออุปกรณ์", variable: formData.eqpt6 == 1 ? 'ปิดผนึกถุงพลาสติก' : (formData.eqpt6 == null ? '-' : 'ลงกล่องเก็บอุปกรณ์') },
          { label: "วันที่รับประกัน", variable: formData.eqptGuaranteeDate ? self.setDateFormat(formData.eqptGuaranteeDate) : '-'  }
        ];
      }
    },
    showBarcodesModal(qiJobId) {
      axios.get(`/Api/QIJobs/BarcodesInfo/${qiJobId}`)
      .then(response => {
        const barcodes = response.data;
        const tableData = barcodes.map((barcode, index) => ({
          index: index + 1,
          barcodeNoOld: barcode.barcodeNoOld || '-'
        }));

        $(this.$refs.barcodeLocalTable).DataTable({
            data: tableData,
            language: {search: "ค้นหา",searchPlaceholder: "BARCODE",},
            columns: [
              { data: 'index', className: 'text-center' },
              { data: 'barcodeNoOld', className: 'text-center' }
            ],
            destroy: true
        });

        $(this.$refs.barcodesModal).modal('show');
      })
      .catch(error => {
        console.error('Error fetching barcodes:', error);
      });
    }
  },
  computed: {
    totalQuantity() {
      return this.items.reduce((sum, item) => sum + (item.quantity || 0), 0);
    },
    totalQuantityService() {
      return this.services.reduce((sum, item) => sum + (item.quantity || 0), 0);
    },
    totalValue() {
      return this.items.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);
    },
    totalValueService() {
      return this.services.reduce((sum, item) => {
        return sum + item.quantity * item.unitPrice;
      }, 0);
    }
  }
};
</script>
<style lang="css">
.border-dashed {
  border: 1px dashed;
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// App/Components/QIJob/QIJobDetail.vue